import React, { useState, useEffect } from 'react'
// import PropTypes from 'prop-types'
import axios from 'axios'
import WorkforceTable from './WorkforceTable'
import Dialog from '../../../../../components/Dialog'
import UploadWorkforce from './UploadWorkforce'
import { get } from 'lodash'

export default function Workforce(props) {

	const [workforceData, setWorkforceData] = useState([])
	const [workForceDataVersion, setWorkForceDataVersion] = useState(0)
	const [uploadWorkforceDlgOpen, setUploadWorkforceDlgOpen] = useState(false)

	useEffect(() => {
		if(props.selectedForecast){
			axios(`/api/workforce_forecast/${props.selectedForecast.value}`)
				.then((result) => {
					setWorkforceData(check(result.data.data))
				})
				.catch((error) => {
					console.log(error)
					setWorkforceData([])
				})
		}
	}, [props.selectedForecast, workForceDataVersion])

	const createWorkforce = async (workForceFormdata) => {
		const payload = {
			...workForceFormdata
		}
		try {
            await axios.post(`/api/workforce_forecast`, payload)
            setWorkForceDataVersion(workForceDataVersion+1)
        } catch(e) {
			console.log(e)
        }
	}

	const updateWorkforce = async (workForceFormdata) => {
		const payload = {
			...workForceFormdata
		}
		try {
			await axios.put(`/api/workforce_forecast`, payload)
			axios.get('/api/company/update_company_currencies')
            setWorkForceDataVersion(workForceDataVersion+1)
        } catch(e) {
			console.log(e)
        }
	}

	const deleteWorkforce = async (workforceId) => {
		try {
			let status = false
			const res = await axios.delete(`/api/workforce_forecast/${workforceId}`)
			axios.get('/api/company/update_company_currencies')
			status = get(res, 'data.status', false)
			setWorkForceDataVersion(workForceDataVersion+1)
			return status
        } catch(e) {
			console.log(e)
			return false
		}
	}

	const downloadWorkforceTemplate = async () => {
		const fileName = `forecast_${props.selectedForecast.value}_template.xlsx`
		const response = await axios.get(`/api/workforce_forecast/download_sample_workforce_file?file_name=${fileName}`)
        window.open(response.data.data, "_blank")
	}

	const downloadWorkforceData = async () => {
		const fileName = `forecast_${props.selectedForecast.value}_data.xlsx`
		const response = await axios.post(`/api/download_workforce_file?file_name=${fileName}`, {forecast_id: props.selectedForecast.value})
        window.open(response.data.data, "_blank")
	}

	const workforceUploaded = () => {
		setUploadWorkforceDlgOpen(false)
		setWorkForceDataVersion(workForceDataVersion+1)
	}
/**
 * Currently set for latest to see if duplicate and turn red
 * these conditions are applied in for loop
 * latest red condition is  var i = (index + 1);(i !== apiData.length && !currentObj.duplicate); i++
 * oldest red condition is var i = (index - 1);(i !== -1 && !currentObj.duplicate); i-1
 */
	const check = (apiData) => {
		const duplicateChecked = apiData.map((currentObj, index) => {
			for(var i = (index + 1);(i !== apiData.length && !currentObj.duplicate); i++){
				if(currentObj.company_function_id === apiData[i].company_function_id
					&& currentObj.company_title_id === apiData[i].company_title_id
					&& currentObj.job_category === apiData[i].job_category
					&& currentObj.job_level === apiData[i].job_level
					&& currentObj.country_id === apiData[i].country_id
					&& currentObj.city_id === apiData[i].city_id)
				{
					currentObj.duplicate = true
				}
				else {
					currentObj.duplicate = false
				}
			}
			return currentObj
		})
		return duplicateChecked
	}

    return (
		<>
			<WorkforceTable
				data={workforceData}
				masterData={props.masterData}
				selectedForecast={props.selectedForecast}
				onUploadTemplate={() => setUploadWorkforceDlgOpen(true)}
				onDownloadTemplate={downloadWorkforceTemplate}
				onDownloadData={downloadWorkforceData}
				createWorkforce={createWorkforce}
				updateWorkforce={updateWorkforce}
				deleteWorkforce={deleteWorkforce}
			/>
			{ props.selectedForecast ?
				<Dialog
					size={'sm'}
					title={'Upload WorkForce Data'}
					isOpen={uploadWorkforceDlgOpen}
					onClose={() => setUploadWorkforceDlgOpen(false)}
				>
					<UploadWorkforce
						onWorkforceUpload={workforceUploaded}
						onDownloadTemplate={downloadWorkforceTemplate}
						selectedForecast={props.selectedForecast}
					/>
				</Dialog>
				:
				null
			}
		</>
    )
}

